import React from "react";
import Header from "../../components/header/header";
import Form from "../../components/form/form";

const Home = () => {
  return (
    <>
      <Header />
      <Form />
    </>
  );
};

export default Home;
